import React, { useState, useEffect } from 'react';
import Styled from 'styled-components';

const Paragraph = Styled.p`
  font-size: 16px;
  font-weight: 700;
  word-break: break-word;

  > b {
    background: #fcefc1;
  }
`;

const normalizeMatch = str =>
  str
    .normalize('NFD')
    .replace(/\p{Diacritic}/gu, '')
    .toLowerCase()
    .trim();

const HighlightParagraph = props => {
  const { text, term, totalTermFound } = props;
  const [paragraph, setParagraph] = useState('');
  const [highlight, setHighlight] = useState('');
  const regEx = new RegExp(normalizeMatch(highlight));
  const termFound = normalizeMatch(text).includes(normalizeMatch(highlight));

  const applyHighlight = () => {
    const arr = [];
    const textNormalized = normalizeMatch(text);
    const split = textNormalized.split(regEx);

    split.map(str => arr.push(str, <b key={Math.random()}>{highlight}</b>));
    arr.pop();
    arr.join('');
    return setParagraph(arr);
  };

  useEffect(() => {
    if (highlight && termFound) {
      applyHighlight();
    }
  }, [highlight]);

  useEffect(() => {
    if (totalTermFound && term) {
      setHighlight(term.trim());
    }
    return () => setHighlight('');
  }, [totalTermFound]);

  if (!highlight || !termFound) {
    return <Paragraph>{text}</Paragraph>;
  }

  return <Paragraph>{paragraph}</Paragraph>;
};

HighlightParagraph.defaultProps = {
  text: '',
  term: '',
};

export default HighlightParagraph;
